import * as React from 'react';
import { Star as Star$1 } from '@sravni/react-icons';
import { useStyles, noop } from '@sravni/react-utils';
import { Icon } from '../../Icon/src/Icon.js';
import modules_d76667db from '../styles/Rate.module.less.js';

const Star = (props) => {
    const { className, index, value, size, fractional, disabled, onClick, onHover } = props;
    const thirdFilled = value && value > index;
    const halfFilled = value && value > index + 0.3;
    const threeQuartersFilled = value && value > index + 0.5;
    const fullFilled = value && value > index + 0.8;
    const focusedSecond = value && value >= index + 1;
    const cx = useStyles(modules_d76667db);
    const classNames = cx(className, 'star-container', {
        disabled,
    });
    const starClassNames = cx('star', {
        disabled,
        [`size-${size}`]: size,
        fill: focusedSecond,
    });
    const halfStarClassNames = cx('star', 'half', {
        disabled,
        [`half-${size}`]: size,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'third-filled': thirdFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'half-filled': halfFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'three-quarters-filled': threeQuartersFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'full-filled': fullFilled,
        fill: thirdFilled || halfFilled || threeQuartersFilled || fullFilled,
    });
    const handleClick = React.useCallback((event) => {
        onClick?.(event, index);
    }, [index, onClick]);
    const handleHover = React.useCallback((event) => {
        onHover?.(event, index);
    }, [index, onHover]);
    return (React.createElement("div", { className: classNames, onClick: disabled ? noop : handleClick, onMouseMove: disabled ? noop : handleHover },
        fractional ? React.createElement(Icon, { className: halfStarClassNames, icon: React.createElement(Star$1, null) }) : null,
        React.createElement(Icon, { className: starClassNames, icon: React.createElement(Star$1, null) })));
};
Star.displayName = 'Star';

export { Star };
//# sourceMappingURL=Star.js.map
